import { Directive, Input } from '@angular/core';

import { InputTypes } from 'app/shared/enums/input-types.enum';

import { BaseControlDirective } from './base-control.directive';

@Directive()
export abstract class CommonInputControlDirective extends BaseControlDirective<string> {
  @Input() public controlType: InputTypes = InputTypes.Text;
  @Input() public placeholder = '';
  @Input() public mask = '';
  @Input() public ariaLabel = '';
  @Input() public testId = '';

  public showPassword = false;
  public inputTypes = InputTypes;

  public get currentPasswordIcon(): string {
    return this.showPassword ? 'parent/icon-eye-open.svg' : 'parent/icon-eye-close.svg';
  }

  public togglePasswordIcon(): void {
    this.showPassword = !this.showPassword;
  }

  public currentControlType(): string {
    if (this.controlType !== InputTypes.Password) {
      return this.controlType;
    }

    return this.showPassword ? InputTypes.Text : InputTypes.Password;
  }
}
